import React, { createContext, useContext, useState } from 'react';


const AuthContext = createContext({})

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider')
  }
  return context
}

export const AuthProvider = ({ children }) => {
  // Mock authenticated user - bypass authentication
  const [user] = useState({
    id: 'mock-user-id',
    email: 'mock@modularflow.com',
    role: 'authenticated'
  })
  const [loading] = useState(false)

  // Auth methods (no-op for bypass mode)
  const signIn = async (email, password) => {
    return { data: { user }, error: null }
  }

  const signOut = async () => {
    return { error: null }
  }

  const signUp = async (email, password, options = {}) => {
    return { data: { user }, error: null }
  }

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      signIn,
      signUp,
      signOut,
      isAuthenticated: true // Always authenticated
    }}>
      {children}
    </AuthContext.Provider>
  );
}
